import gql from 'graphql-tag'

export default gql`
    mutation sendForgottenPasswordLink($username: String!){
      sendForgottenPasswordLink(username: $username)
    }
`